module.exports = __webpack_public_path__ + "img/assalam.f6680c8c.jpeg";